document.addEventListener('click', function (e) {
    if (e.target.closest('.liroma-btn--primary-cstm')) {
        const quizBtn = document.querySelector('.vq2-quiz-btn');
        if (quizBtn) {
            quizBtn.click();
        }
    }
});